<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="12">
                <v-sheet min-height="70vh" rounded="lg" class="pa-10">
                    <p>imprint</p>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'imprint',
};
</script>
